import api from "./axios";

const BASE = "/broadcasts";

export const listBroadcasts = async (params = {}) => {
  return api.get(BASE, { params });
};

export const getBroadcastById = async (id) => {
  return api.get(`${BASE}/${id}`);
};

/**
 * Create a broadcast. Uses multipart/form-data when an attachment is present.
 * @param {Object} payload - { title, body, targetType, targetIds, priority, sendNow, scheduledAt }
 * @param {File} [file]
 */
export const createBroadcast = async (payload, file) => {
  const formData = new FormData();
  Object.entries(payload).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    if (Array.isArray(value)) {
      formData.append(key, JSON.stringify(value));
    } else {
      formData.append(key, value);
    }
  });
  if (file) formData.append("attachment", file);

  return api.post(BASE, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const deleteBroadcast = async (id, reason) => {
  return api.delete(`${BASE}/${id}`, { data: { reason } });
};

export const exportBroadcasts = async (params = {}) => {
  return api.get(`${BASE}/export`, {
    params,
    responseType: "blob",
  });
};

export const downloadBroadcastAttachment = async (id) => {
  return api.get(`${BASE}/${id}/attachment`, {
    responseType: "blob",
  });
};
